import { combineReducers } from 'redux'
import * as types from 'models/actionTypes'
import * as ratingTypes from 'models/ratings/constants'

const initialState = {
    isFetching: false,
    ratingsByJobId: {},
    options: null,
}

const processServerRating = (rating) => ({
    [rating.ratingTag]: {
        ...rating,
    },
})

const ratingsByJobId = (state = initialState.ratingsByJobId, action) => {
    switch (action.type) {
        case types.RECEIVE_RATINGS: {
            const ratings = [...action.ratings]
            ratings.sort((a, b) => a.id - b.id)
            return {
                ...state,
                [action.jobId]: Object.assign({}, state[action.jobId], ...ratings.map(processServerRating)),
            }
        }
        case types.RECEIVE_RATING:
            if (!Object.keys(action.rating).length) {
                return state
            }
            return {
                ...state,
                [action.jobId]: {
                    ...state[action.jobId],
                    ...processServerRating(action.rating),
                },
            }
        case types.SUBMIT_RATING: {
            const rating = state[action.jobId] && state[action.jobId][action.tagId]
            if (
                (action.kind === ratingTypes.RATING && !action.value) ||
                (action.kind === ratingTypes.SEVERITY && !action.value) ||
                (action.kind === ratingTypes.NOTE && !action.note) ||
                (action.kind === ratingTypes.TAG && !action.value)
            ) {
                const newState = { ...state }
                delete newState[action.jobId][action.tagId]
                return newState
            }
            return {
                ...state,
                [action.jobId]: {
                    ...state[action.jobId],
                    [action.tagId]: {
                        ...rating,
                        value: action.value,
                        note: action.note,
                        job: action.jobId,
                        ratingTag: action.tagId,
                    },
                },
            }
        }
        default:
            return state
    }
}

const options = (state = initialState.options, action) => {
    switch (action.type) {
        case types.RECEIVE_RATING_OPTIONS: {
            const ops = [...action.options]
            ops.sort((a, b) => a.position - b.position)
            return ops
        }
        default:
            return state
    }
}

const isFetching = (state = initialState.isFetching, action) => {
    switch (action.type) {
        case types.REQUEST_RATINGS:
        case types.SUBMIT_RATING:
            return true
        case types.RECEIVE_RATINGS:
        case types.RECEIVE_RATING:
            return false
        default:
            return state
    }
}

export default combineReducers({
    ratingsByJobId,
    isFetching,
    options,
})
